import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'reactstrap'
import { Table,Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ReportGeneration = ({dateData,dataForReport}) => {
  
    const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"

    // Style object for the sticky table headers
    const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1, // Ensures header is above the scrolling content
    };

    // state for setting the report data
    const[report,setReport] = useState([]);
    console.log(report)
    // state for status count
    const[status,setStatus] = useState([]);
    console.log(status)
    useEffect(()=>{
      if(dataForReport){
        setReport(dataForReport.orders)
        setStatus(dataForReport.status_count)
      }
    },[dataForReport])

    const handleDownload = () => {
      // 1. Prepare status summary as array of arrays
      const statusSummary = [
        ["Status Summary"], // Title row
        ...status.map(stat => [`${stat.status} - ${stat.count}`]), // Each status
        [`Total - ${status.reduce((sum, s) => sum + s.count, 0)}`], // Total row
        [], // Empty row for spacing
      ];

      // 2. Prepare order data as array of objects
      const dataToExport = report.map((item) => ({
        "Order Number": item.order_id,
        "File Number": item.file_num,
        "Product Type":item.product_type,
        "Credit Used":item.credit_used,
        // "Order Date": item.created_date?.split("T")[0],
        "Order Date": item.created_date ? new Date(item.created_date).toLocaleDateString('en-US') : '',
        "Organization": item.org_detail?.name,
        // "Processed Date": item.updated_date?.split("T")[0] || "-",
        "Processed Date": item.updated_date? new Date(item.updated_date).toLocaleDateString('en-US') : '',
        "Status": item.status,
      }));

      // 3. Convert order data to array of arrays
      const orderSheetData = [
        Object.keys(dataToExport[0]), // Header row
        ...dataToExport.map(Object.values),
      ];

      // 4. Combine both into final sheet data
      const finalSheetData = [...statusSummary, ...orderSheetData];

      // 5. Create worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(finalSheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      // 6. Download
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

      saveAs(dataBlob, `Order_Report_${today}.xlsx`);
    }

  return (
    <Container fluid> 
      <Row>
        <Col>
          <Row className='mt-2'>
            <Col>
              <Button color="primary" onClick={handleDownload}>
                Download Report (xls)
              </Button>
            </Col>
          </Row>

          <Row className='mt-3'>
            <Col>
              {dateData === today ? <h6>Daily Report Summary - {dateData}</h6> : <h6>Report Summary from {dateData.startDate} to {dateData.endDate}</h6>}
            </Col>
          </Row>
          <Row>
            <Col>
              <h6>Status Summary</h6>
              <ul style={{ paddingLeft: '1rem' }}>
                {status?.map((stat,index)=>(
                  <li key={index}>{stat.status} - {stat.count}</li>
                ))}
                <li>
                  Total - {status?.reduce((total,item)=>total+ item.count,0)}
                </li>
              </ul>
            </Col>
          </Row>
          <Row>
                <div className='table-rep-plugin'>
                    <div className='table-responsive mb-0' style={{ maxHeight: "400px",minHeight:"340px", overflowY: "auto" }}>
                        <Table className='table table-striped table-bordered'>
                            <Thead>
                                <Tr>
                                    <Th style={stickyHeaderStyle}>Order Number</Th>
                                    <Th style={stickyHeaderStyle}>File Number</Th>
                                    <Th style={stickyHeaderStyle}>Product Type</Th>
                                    <Th style={stickyHeaderStyle}>Credit Used</Th>
                                    <Th style={stickyHeaderStyle}>Order Date</Th>
                                    <Th style={stickyHeaderStyle}>Organization</Th>
                                    <Th style={stickyHeaderStyle}>Processed Date</Th>
                                    {/* <Th style={stickyHeaderStyle}>Appraiser</Th> */}
                                    <Th style={stickyHeaderStyle}>Status</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {Array.isArray(report)&& report.map((repData, index)=>(
                                    <Tr key={index}>
                                        <Td>{repData.order_id}</Td>
                                        <Td>{repData.file_num}</Td>
                                        <Td>{repData.product_type}</Td>
                                        <Td>{repData.credit_used}</Td>
                                        {/* <Td>{repData.created_date?.split('T')[0]}</Td> */}
                                        <Td>{repData.created_date ? new Date(repData.created_date).toLocaleDateString('en-US') : ''}</Td>
                                        <Td>{repData.org_detail.name}</Td>
                                        {/* <Td>{repData.updated_date?.split('T')[0] || '-'}</Td> */}
                                        <Td>{repData.updated_date ? new Date(repData.updated_date).toLocaleDateString('en-US') : ''}</Td>
                                        {/* <Td>{repData.}</Td> */}
                                        <Td>{repData.status}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>
                </div>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default ReportGeneration
